import { ReusableWizard } from "@oysterhr/feature-components"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { useMemo } from "react"
import { NewBankAccountDetails } from "../components/NewBankAccountDetails"

export const BankDetailsStep = () => {
  const stripePromise = useMemo(() => loadStripe(window.gon.stripeOysterHrLtdPublishableKey), [])

  return (
    <ReusableWizard.Step title="Add payment method" subtitle="Next: Authorize Direct Debit">
      <Elements stripe={stripePromise}>
        <NewBankAccountDetails />
      </Elements>
    </ReusableWizard.Step>
  )
}
